export default __webpack_public_path__ + "static/media/ShieldingGasesTable.d6b79f67.PNG";